export const validateLabelSettings = (value: string): true | string => {
  if (!value.trim()) return true;
  try {
    const parsed = JSON.parse(value);
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
      return 'Must be a JSON object, e.g. {"key": "value"}';
    }
    return true;
  } catch {
    return 'Invalid JSON — check the syntax and try again';
  }
};

export const normalizeLabNames = (labNames: string[]): string[] => {
  return labNames.map((labName) => labName.trim().toLowerCase());
};

export const validateDuplicateLabName = (value: string, existingLabNames: string[]): true | string => {
  const normalizedValue = value.trim().toLowerCase();
  if (!normalizedValue) return true;

  return existingLabNames.includes(normalizedValue) ? 'A lab with this name already exists' : true;
};

export const parseLabelSettings = (value: string): Record<string, unknown> | undefined => {
  return value.trim() ? (JSON.parse(value) as Record<string, unknown>) : undefined;
};
